export const INSIGHTS_PANEL = 'INSIGHTS_PANEL' as const;
export const VIEW_SETTINGS_PANEL = 'VIEW_SETTINGS_PANEL' as const;
